module.exports = __webpack_public_path__ + "static/media/webcam-slash.f4368a4c.svg";